import React from "react";
import { Tabs } from "@base-ui/react/tabs";
import { useSettings } from "./SettingsProvider";
import styles from "./SettingsNavLink.module.scss";

interface Props {
    eventKey: string;
    children: React.ReactNode;
}

export const SettingsNavLink: React.FC<Props> = ({ eventKey, children }) => {
    const { validPaths } = useSettings();

    if (!validPaths.includes(eventKey)) {
        return null;
    }

    return (
        <Tabs.Tab value={eventKey} className={styles.link}>
            {children}
        </Tabs.Tab>
    );
};
